<template>
  <p>Shows gift wrappers.</p>
</template>

<script>
export default {
  name: 'PagesGiftWrappersWidget',
  props: { value: { type: String } },
  data() {
    return { content: 'static' }
  },
}
</script>
